var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MinistriesMens'),_c('MinistriesWomens'),_c('MinistriesHealth'),_c('MinistriesPrayer'),_c('MinistriesFamily'),_c('MinistriesSingles'),_c('GetConnected'),_c('EventsStudy'),_c('GetInTouch')],1)}
var staticRenderFns = []

export { render, staticRenderFns }